import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useHeroImages } from '../hooks/useHeroImages';
export function Hero() {
  const {
    images
  } = useHeroImages();
  const [currentIndex, setCurrentIndex] = useState(0);
  // Auto-rotate images
  useEffect(() => {
    if (images.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [images.length]);
  // Reset index if images change and current index is out of bounds
  useEffect(() => {
    if (currentIndex >= images.length) {
      setCurrentIndex(0);
    }
  }, [images.length, currentIndex]);
  const currentImage = images[currentIndex]?.url || 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=2000';
  return <section className="relative min-h-[65vh] sm:min-h-[75vh] md:min-h-screen w-full overflow-hidden bg-gray-900" data-id="element-209">
      {/* Background Image with Modern Gradient Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-210">
        <AnimatePresence mode="popLayout" data-id="element-211">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          scale: 1.1
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 1.5,
          ease: 'easeInOut'
        }} className="absolute inset-0" data-id="element-212">
            <img src={currentImage} alt="Modern corporate office construction" className="h-full w-full object-cover" data-id="element-213" />
          </motion.div>
        </AnimatePresence>

        {/* Permanent overlay to ensure text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/60 to-transparent z-10" data-id="element-214" />
      </div>

      {/* Content */}
      <div className="relative z-20 flex min-h-[65vh] sm:min-h-[75vh] md:min-h-screen flex-col justify-center px-4 py-16 sm:px-6 sm:py-20 lg:px-16" data-id="element-215">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-5xl" data-id="element-216">
          <span className="mb-4 inline-block rounded-full bg-blue-600/20 px-4 py-1.5 text-sm font-semibold text-blue-100 backdrop-blur-md border border-blue-500/30" data-id="element-217">
            Construcción Corporativa
          </span>
          <h1 className="mb-6 text-4xl font-extrabold tracking-tight text-white sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl leading-[1.1] sm:leading-[1.1]" data-id="element-218">
            Construimos espacios que{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400" data-id="element-219">
              generan negocios.
            </span>
          </h1>
          <p className="mb-8 sm:mb-10 text-lg sm:text-xl font-light text-gray-200 sm:text-2xl md:max-w-2xl leading-relaxed" data-id="element-220">
            Especialistas en habilitación de oficinas y retail. Transformamos
            metros cuadrados en experiencias productivas.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-221">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="group w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-blue-600 to-indigo-600 px-8 py-4 text-lg font-bold text-white shadow-lg shadow-blue-600/30 transition-all hover:shadow-blue-600/50" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-222">
              Conversemos tu proyecto
              <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-223" />
            </motion.button>

            <Link to="/proyectos" data-id="element-224">
              <motion.button whileHover={{
              scale: 1.05,
              backgroundColor: 'rgba(255,255,255,0.15)'
            }} whileTap={{
              scale: 0.95
            }} className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full border border-white/30 bg-white/10 px-8 py-4 text-lg font-semibold text-white backdrop-blur-sm transition-all" data-id="element-225">
                Ver portafolio
              </motion.button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}